import AiAssistThreadsAPI from 'dashboard/api/aiAssist/threads';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'AiAssistThreads',
  API: AiAssistThreadsAPI,
});
